<script setup lang="ts">
type ErrorLayoutProperties = {
  title: string
  description: string
}

defineProps<ErrorLayoutProperties>()
</script>

<template>
  <div class="flex h-screen w-screen flex-col items-center justify-center gap-4 text-white" style="background-color: #0b3d3a">
    <h1 class="text-4xl font-normal text-white">{{ title }}</h1>
    <p class="text-lg">{{ description }}</p>
  </div>
</template>
